import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { removePlusSign, getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import {
    //model
    wirelessOtherModel
    //action
    , setOtherRequestOptions
    , setSubscriptionDetails
    , setFormSubmitted
    , setFormLoading
    , setResetLoading
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-other.settings';

export const otherModelAInitialState = wirelessOtherModel;

const defaultState = () => ({
    isFormLoading: false,
    isResetLoading: false,
    subscription: {}
    , otherRequestOptions: [{ "Key": 23, "Value": "Other" }]
    , formSubmitted: false
});

const initialState = defaultState();

export const wirelessOtherActions = {
    setLoadForm: (isLoad = false) => (dispatch, state) => {
        dispatch({
            type: setFormLoading,
            data: isLoad
        });
    },

    onLoadUpdateOtherRequest: (subscriptionList, circuitCodePropName) => (dispatch, state) => {
        const { requestData } = state().requestDetail;

        dispatch(actions.reset('wirelessPortOutFormA'));

        if (requestData.Circuit.CircuitCode) {
            dispatch(actions.change("wirelessOtherFormA.circuitCode", requestData.Circuit.CircuitCode));
            dispatch(actions.change('wirelessOtherFormA.circuitId', requestData.Circuit.CircuitId ?? 0));
            dispatch(actions.change('wirelessOtherFormA.otherRequestTypeId', requestData.Order.RequestType.RequestTypeID));
            dispatch(actions.change('wirelessOtherFormA.otherRequestDetails', requestData.Order.RequestDetails));
          

            var subscription = subscriptionList ? subscriptionList.find(o => o[circuitCodePropName] === requestData.Circuit.CircuitCode) : 0 ;
            dispatch({ type: setSubscriptionDetails, data: subscription });
        }
        else {
            dispatch(actions.reset('wirelessOtherFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }
    },

    fetchOtherOptions: () => (dispatch) => {
        fetchOtherRequestOptions(dispatch, "", true);
    }
    , onSubscriptionSelect: (value, propsName, objects, index) => (dispatch, state) => {

        const { wirelessOtherFormA } = state().form;
        const { takeActionCircuitId } = state().createRequest;
        if (value === '' || !propsName) {
            fetchOtherRequestOptions(dispatch, '', false);
            dispatch(actions.reset('wirelessOtherFormA.circuitCode'));
            dispatch(actions.reset('wirelessOtherFormA.circuitId'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            if(propsName){
                var obj=null              
                if(objects !== null && objects !== undefined) {
                    if(index !== -1 && index !== undefined && index !== null) {
                        obj=objects[index]
                    }
                    else if(objects.length === 1) {
                        obj=objects.find(o => o[propsName] === value);
                    }
                    else if (objects.length > 1) {
                        obj = objects.find(o => o[propsName] === value & o['CircuitId'] === takeActionCircuitId);
                    }
                }
                if (obj != null && parseInt(obj.CircuitId) !== parseInt(wirelessOtherFormA.circuitId)) {
                    dispatch(actions.change('wirelessOtherFormA.circuitCode', value));
                    dispatch(actions.change('wirelessOtherFormA.circuitId', obj.CircuitId));
                    dispatch({ type: setSubscriptionDetails, data: obj });

                    fetchOtherRequestOptions(dispatch, obj.CircuitCode, false);
                }
            }   
            
        }
    }

    , submitRequest: () => async (dispatch, state) => {
        const { wirelessOtherFormA } = state().form;
        const { isRequestOnBehalf, requestOnBehalfData, isUpdateRequest } = state().createRequest;
        const { subscription } = state().wirelessOtherRequest;

        const userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.vip = requestOnBehalfData.Vip;
        }

        userData.managerApproverId = isRequestOnBehalf ?
        requestOnBehalfData.CostCodeApproverEmployeeId : sessionStorage.CostCodeAuthorizerID;

        let changeRequestData = {
                ...userData
                , ...wirelessOtherFormA
                , VendorDetailId: subscription.VendorDetailId
        }

        if (isUpdateRequest) {
            const { requestData } = state().requestDetail;
            const { wirelessOtherFormA } = state().form;

            changeRequestData = {
                ...changeRequestData
                , ...wirelessOtherFormA
                , OrderId: requestData.Order.OrderId
                , OrderInfoId: requestData.OrderInfoId
                , CircuitOrderId: requestData.CircuitOrderId
                , OrderHistoryId: requestData.OrderHistoryId
                , CircuitCode: wirelessOtherFormA.circuitCode
                , CircuitId: wirelessOtherFormA.circuitCode ? wirelessOtherFormA.circuitId : 0

            }
        }

        const data = {
            ChangeRequestModel: changeRequestData,
            IsAmending: isUpdateRequest
        };

        dispatch({ type: setFormSubmitted, data: true });

        var res = await httpPost('external/otherRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }
    , resetWirelessOtherForm: (isResetRequestOnBehalf = false) => (dispatch, state) => {

        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }
        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelessOtherFormA.circuitCode'));
            dispatch(actions.reset('wirelessOtherFormA.circuitId'));
            dispatch({ type: setSubscriptionDetails, data: {} });

            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }
        else if (!isResetRequestOnBehalf) {
            dispatch(actions.reset('wirelessOtherFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }
        dispatch(actions.reset('wirelessOtherFormA'));
        dispatch({ type: setFormSubmitted, data: false });
    }
}

async function fetchOtherRequestOptions(dispatch, id, defaultDisplay) {

    id = removePlusSign(id);

    const res = await httpGet('external/otherRequest/getOtherRequestTypes/'
        + defaultDisplay + '/'
        + id);

    if (res) {
        dispatch({ type: setOtherRequestOptions, data: res });
    } else {
        dispatch({ type: setOtherRequestOptions, data: initialState.otherRequestOptions });
    }

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setOtherRequestOptions:
            return {
                ...state
                , otherRequestOptions: action.data
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };

        case setFormLoading:
            return {
                ...state
                , isFormLoading: action.data
            }
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            }
        default: return state;
    }
}